export function getGroup(auth) {
    const activeGroup = auth.grupos[auth.grupo_ativo];

    return {
        ...activeGroup,
        getEmpresa: () => ({
            ...activeGroup.emp,
            isTransportadora: () =>
                activeGroup.emp.tipo.toLowerCase() === "transportadora",
            isDistribuidora: () =>
                activeGroup.emp.tipo.toLowerCase() === "distribuidora",
        }),
        getUser: () => ({
            ...activeGroup.user,
            isGroup(group = "") {
                return (
                    activeGroup.user.grupo.toLowerCase() === group.toLowerCase()
                );
            },

            isGroupAtivos() {
                return (
                    activeGroup.user.grupo.toLowerCase() === "embarcador" ||
                    activeGroup.user.grupo.toLowerCase() === "entregador" ||
                    activeGroup.user.grupo.toLowerCase() === "destinatario"
                );
            },

            isEmbarca() {
                return activeGroup.user.grupo.toLowerCase() === "embarcador"
            }
        }),
    };
}

export function getBases(auth, { active = false, name = false } = {}) {
    return auth.bases
        .filter((base) => (active === true ? base.active : true))
        .map((base) => (name === true ? base.name : base));
}

export function getCidadeBase(data) {
    let bas = data.auth.bases.filter((b) => b.name === data.base);
    return bas[0].cidade;
}

export function isAdmin(auth) {
    try {
        return auth.grupos[auth.grupo_ativo].user.grupo == "ADMIN"
    } catch { return undefined }
}

export function isSuper(auth) {
    try {
        return auth.grupos[auth.grupo_ativo].user.grupo == "SUPER"
    }
    catch { return undefined }
}

export const getAllCNPJs = (auth) => {
    return [...new Set([...auth.grupos[auth.grupo_ativo].emp.cnpjs, ...auth.bases.reduce((acc, cur) => {
        return [...acc, ...cur?.cnpjs]
    }, [])])]
}
